import { dispatch } from '~/state';

const TargetingClient = {
  setAsReady: () => dispatch({ type: 'targetingReady' }),
  cities: {
    add: city => dispatch({ type: 'addCity', payload: city }),
    remove: city => dispatch({ type: 'removeCity', payload: city }),
    clear: () => dispatch({ type: 'clearCities' }),
  },
  audiences: {
    add: a => dispatch({ type: 'addCustomAudience', payload: a }),
    remove: a => dispatch({ type: 'removeCustomAudience', payload: a }),
    clear: () => dispatch({ type: 'clearCustomAudiences' }),
  },
  interests: {
    add: i => dispatch({ type: 'addInterest', payload: i }),
    remove: i => dispatch({ type: 'removeInterest', payload: i }),
    clear: () => dispatch({ type: 'clearInterests' }),
  },
};

export default TargetingClient;
